import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 15.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10m6.013-8.586a7.002 7.002 0 0 1-5.015 10.516l.002.07v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 0 1-2 0v-1H8a1 1 0 0 1 0-2h1v-1q0-.036.002-.07A7.002 7.002 0 0 1 10 3.5a6.98 6.98 0 0 1 4.745 1.853l1.85-1.85H15.01a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V4.917z"
    }, null, -1)
  ]))]))
}
export default { render: render }